"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PHONE_NUMBER_INPUT = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    PHONE_NUMBER_INPUT = (0, _cxs["default"])({
  " input[type=number]": {
    paddingLeft: "10px !important"
  },
  " input[type=number]::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  },
  "input[type=number]::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  }
});

exports.PHONE_NUMBER_INPUT = PHONE_NUMBER_INPUT;